<gg-generic-popup (primaryButtonClick)="confirm()" (secondaryButtonClick)="cancel()"></gg-generic-popup>
